"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
exports.default = (function (state, isDisabled) {
    if (isDisabled === void 0) { isDisabled = false; }
    var border = classnames_1.default({
        'border-gray-40': isDisabled || !state,
        'border-success': !isDisabled && state === 'success',
        'border-attention': !isDisabled && state === 'attention',
        'border-error': !isDisabled && state === 'error',
        'border-highlight': !isDisabled && state === 'highlight',
    });
    var background = classnames_1.default({
        'bg-gray-20': isDisabled,
        'bg-success': !isDisabled && state === 'success',
        'bg-attention': !isDisabled && state === 'attention',
        'bg-error': !isDisabled && state === 'error',
        'bg-highlight': !isDisabled && state === 'highlight',
    });
    var color = classnames_1.default({
        'text-gray-60': isDisabled,
        'text-cta-main': !isDisabled && state === 'success',
        'text-rating': !isDisabled && state === 'attention',
        'text-error': !isDisabled && state === 'error',
        'text-ice': !isDisabled && state === 'highlight',
    });
    return { border: border, background: background, color: color };
});
//# sourceMappingURL=getInputTheme.js.map